import { API_METHODS } from "../constants/api.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { AppEnvVariables } from "../constants/environment.constants";
import { BasicPackagesIds, ParticpantPackagesIds } from "constants/app.constant";
const getCountryList = async (payload: any = {}) => {
  const clientsSearchUrl =
    AppEnvVariables.API_DOMAIN +
    `/api/country?personid=${payload.personId}&clientid=${payload.clientId}`;
  const config: any = {
    method: API_METHODS.GET,
    url: clientsSearchUrl
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

const getAppConfig = async (apiPayload: any) => {
  const clientsSearchUrl = AppEnvVariables.API_DOMAIN + `/api/config`;
  const config: any = {
    method: API_METHODS.POST,
    url: clientsSearchUrl,
    data: apiPayload
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

const getReportFilters = async (apiPayload: any) => {
  const clientsSearchUrl = AppEnvVariables.API_DOMAIN + `/api/filter`;
  const config: any = {
    method: API_METHODS.POST,
    url: clientsSearchUrl,
    data: apiPayload
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

const getReportData = async (reportType: string, apiPayload: any) => {
  const clientsSearchUrl =
    AppEnvVariables.API_DOMAIN +
    `/api/pe/report/genderreport?reportName=${reportType}`;
  const config: any = {
    method: API_METHODS.POST,
    url: clientsSearchUrl,
    data: apiPayload
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

const isParticipatePackage = (productBrandId: string | number) => { 
  if (BasicPackagesIds.includes(Number(productBrandId)) || ParticpantPackagesIds.includes(Number(productBrandId))) {
    return true;
  }
  return false;
};

export { getCountryList, getAppConfig, getReportFilters, getReportData , isParticipatePackage};
